import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	template: `
		<base-support-modal
		[title]="title"
		(onOk)="ok()"
	>
		логов с siteId === "{{ siteId }}": {{ stats.length }} !
		
		<table class="table">
			<thead>
				<tr>
					<th>item</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let log of stats">
					<td>
						{{ log.time }}
					</td>
					
					<td>
						{{ log.mark }}
					</td>
					
					<td>
						{{ log.referer }} => {{ log.originalUrl }}
					</td>
				</tr>
			</tbody>
		</table>
	</base-support-modal>
	`
})
export class SiteHistoryModal extends BaseSupportModalComponent {
	public siteId: string = '';
	public stats: object[] = [];

	async ok() {
		
	}
}
